import type { AccountSocialField, SocialPlatform } from "@/types/account";
import { GlobeAltIcon } from "@heroicons/vue/24/outline";
import { cloneDeep } from "lodash-es";

export function getSocialIcon(platform: SocialPlatform) {
  switch (platform) {
    case "facebook":
      return defineAsyncComponent(() => import("@/components/icons/FacebookIcon.vue"));
    case "twitter":
      return defineAsyncComponent(() => import("@/components/icons/TwitterIcon.vue"));
    case "instagram":
      return defineAsyncComponent(() => import("@/components/icons/InstagramIcon.vue"));
    case "linkedin":
      return defineAsyncComponent(() => import("@/components/icons/LinkedinIcon.vue"));
    case "youtube":
      return defineAsyncComponent(() => import("@/components/icons/YoutubeIcon.vue"));
    case "threads":
      return defineAsyncComponent(() => import("@/components/icons/ThreadsIcon.vue"));
    case "tiktok":
      return defineAsyncComponent(() => import("@/components/icons/TiktokIcon.vue"));
    default:
      return GlobeAltIcon;
  }
}

export const socialPlatformDropdownOptions: { label: string; value: SocialPlatform }[] = [
  {
    label: "Twitter",
    value: "twitter",
  },
  {
    label: "Facebook",
    value: "facebook",
  },
  {
    label: "LinkedIn",
    value: "linkedin",
  },
  {
    label: "Instagram",
    value: "instagram",
  },
  {
    label: "YouTube",
    value: "youtube",
  },
  {
    label: "Threads",
    value: "threads",
  },
  {
    label: "TikTok",
    value: "tiktok",
  },
];

export const socialPlatformArr = socialPlatformDropdownOptions.map(p => p.value);

export const socialProfileKeyArr: `${SocialPlatform}-profile`[] = socialPlatformArr.map(
  i => `${i}-profile` as `${SocialPlatform}-profile`
);

export function getAccountSocialField(
  account: (Record<Exclude<SocialPlatform, "threads">, any> & { threads?: any }) | null,
  field: SocialPlatform
): AccountSocialField[] {
  if (!account) return [];
  const data = account[field];
  if (!data) return [];
  if (typeof data === "string") {
    return [
      {
        link: data,
      },
    ];
  }
  if (Array.isArray(data)) {
    const isStringArray = data.every(item => typeof item === "string");
    if (!isStringArray) return cloneDeep(data);
    return data.map(item => ({
      link: item,
    }));
  }
  return [
    {
      link: "n/a",
    },
  ];
}

export function getSocialMediaUrlKey(url: string) {
  const link = url?.toLowerCase() === "n/a" ? "n/a" : url;
  if (!link || link === "n/a") return "_";
  const formatted = normalizeSocialMediaUrl(link);
  return getSha256Hash(formatted);
}
